import { campaignExperimentRedirect, CampaignExperimentLegacyRoute } from './-campaign-experiment-redirects';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests/experiments/$experimentId',
)({
  component: CampaignExperimentLegacyRoute,
  beforeLoad: campaignExperimentRedirect(),
});
